import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { TranslateModule } from '@ngx-translate/core';
import { NgScrollbarModule } from 'ngx-scrollbar';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

import { CoreCommonModule } from '@xbaht/ui/core/common.module';
import { CoreTouchspinsModule } from '@xbaht/ui/core/components/core-touchspins/core-touchspins.module';

import { NavbarComponent } from './navbar/navbar.component';
import { NavbarSearchComponent } from './navbar/navbar-search/navbar-search.component';
import { NavbarBookmarkComponent } from './navbar/navbar-bookmark/navbar-bookmark.component';
import { NavbarCartComponent } from './navbar/navbar-cart/navbar-cart.component';
import { NavbarNotificationComponent } from './navbar/navbar-notification/navbar-notification.component';

@NgModule({
  declarations: [
    NavbarComponent,
    NavbarSearchComponent,
    NavbarBookmarkComponent,
    NavbarCartComponent,
    NavbarNotificationComponent,
  ],
  imports: [
    RouterModule,
    TranslateModule,
    NgbModule,
    CoreCommonModule,
    NgScrollbarModule,
    CoreTouchspinsModule,
  ],
  exports: [NavbarComponent],
})
export class NavbarsModule {}
